export const CONS = {
  TITLE: 'BELL CALL CENTER',
  H1: `Have you verified the customer's identity?`,
  TEXT: `Selecting yes will connect the customer's prescriptions to their account.`,
  YES: 'Yes, connect',
  NO: 'No, go back',
  TAG: 'csr_verify',
  LINK: {
    TITLE: 'For CSR Only',
    VERIFICATION: 'Bypass automated verification',
    TEXT: 'Switch to Rx Wizard/Connect if other verification methods fail.'
  }
};
export const CSR_BYPASS_CONSENT_PAGE_NAME = 'CSR Bypass Consent';

// Translation configuration for CSR page
export const CSR_TRANSLATION_CONFIG = [
  { key: 'CONS', value: CONS, message: JSON.stringify(CONS) },
];

// Helper function to process translated items
export const processCsrTranslations = (translatedItems: any) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  // Parse the CONS object with fallback
  const parseObject = (fallback: any) => {
    const parsed = translatedItems[JSON.stringify(fallback)];
    if (parsed) {
      try {
        return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
      } catch {
        return fallback;
      }
    }
    return fallback;
  };

  return {
    CONS: parseObject(CONS),
  };
};
